import Button from '@material-ui/core/Button';
import { useResetButtonDisabled } from 'components/common/formik';

const EndAdornmentResetButton = () => {
  const [disabled, handleReset] = useResetButtonDisabled();

  return (
    <Button disabled={disabled} onClick={handleReset}>
      Reset
    </Button>
  );
};

export default EndAdornmentResetButton;
